<template>
  <div>
    <div class="floating_btn_icon" @click="openModal('addDriverModal')">
      <div class="floating_btn">
        <div class="floatinig_btn_inner_div">
          <div class="grouped_icons text-center">
            <img src="@/assets/img/chauffer.png" width="80%" />
            <span>
              <img src="@/assets/img/Add.png" width="70%" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <MasterLayout>
      <div class="drivers_first_row">
        <div
          class="card_container"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="row dashboard_card">
            <div class="col-lg-6 col-md-6">
              <p>{{ $t("text.drivers.myDrivers") }}</p>
            </div>
            <div class="col-lg-6 col-md-6 text-right">
              <img src="@/assets/img/purple_chauffer.png" height="" />
            </div>
          </div>
          <div class="dashboard_card_header_section mt-4">
            <h3 class="dashboard_card_header">{{ driversCount }}</h3>
          </div>
        </div>
        <div
          class="drivers_first_row_right_section mr-3 vr__bg"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31 , 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row vehicles_btn_row">
            <div class="col-md-12 col-lg-6">
              <div class="transaction_period_text text-center mt-3">
                {{ $t("text.drivers.generateVouchers") }}
              </div>
            </div>
            <div class="col-md-12 col-lg-6 vouchers_submit">
              <div class="text-center">
                <div class="vehicle_voucher_btns_div_1 text-right mr-3">
                  <button
                    class="mr-3"
                    @click="sendVoucherToDrivers($event, 'send')"
                    :disabled="isButtonDisabled ? true : null"
                    :style="[
                      isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    {{ $t("text.drivers.sendVoucher") }}
                    <i
                      class="fa fa-envelope ml-2"
                      aria-hidden="true"
                      style="color: rgb(75, 44, 114)"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row vehicles_btn_row">
            <div class="col-md-12 vouchers_submit">
              <div class="vehicles_voucher_form mt-3">
                <div class="row mt-3">
                  <div class="col-md-12 col-lg-4">
                    <div class="input__block" ref="amount_input_div">
                      <input
                        type="text"
                        :placeholder="$t('text.drivers.amount')"
                        class="form-control w-100 input_full_width"
                        v-model="amount"
                      />
                    </div>
                    <div ref="amount_error_template"></div>
                  </div>
                  <div class="col-md-6 col-lg-4 input_div_row">
                    <div class="input__block" ref="balance_to_input_div">
                      <input
                        type="text"
                        :placeholder="$t('text.drivers.balanceTo')"
                        class="form-control w-100 input_full_width drop_down_input"
                        v-model="returnBalanceTo"
                        @click="toggleReturnBalanceToDropDownDisplay"
                        readonly
                      />
                    </div>
                    <div
                      class="return_balance_to_drop_dwon"
                      ref="balance_to_drop_down_menu"
                      v-if="toggleReturnBalanceToDropDown"
                    >
                      <hr class="mt-2" />
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        @click="getReturnBalanaceToDropdownItem('Wallet')"
                      >
                        <div class="col-md-8">
                          <h6
                            class="dropdown_header_tex mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.drivers.wallet") }}
                          </h6>
                        </div>
                        <div class="col-md-4 text-right"></div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        @click="getReturnBalanaceToDropdownItem('Bearer')"
                      >
                        <div class="col-md-8">
                          <h6
                            class="dropdown_header_tex mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.drivers.bearer") }}
                          </h6>
                        </div>
                        <div class="col-md-4 text-right"></div>
                      </div>
                    </div>
                    <div ref="balance_to_error_template"></div>
                  </div>
                  <div class="col-md-6 col-lg-4 input_div_row">
                    <div class="input__block" ref="validity_input_div">
                      <input
                        type="text"
                        :placeholder="$t('text.drivers.validity')"
                        class="form-control w-100 input_full_width drop_down_input"
                        v-model="validity"
                        @click="toggleValidityDropDownDisplay"
                        readonly
                      />
                    </div>
                    <div ref="validity_error_template"></div>
                    <div
                      class="validity_dropdown"
                      ref="balance_to_drop_down_menu"
                      v-if="toggleValidityDropdown"
                    >
                      <hr class="mt-2" />
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        @click="getValidityItem('never', 'Never')"
                      >
                        <div class="col-md-8">
                          <h6
                            class="dropdown_header_tex mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.drivers.never") }}
                          </h6>
                        </div>
                        <div class="col-md-4 text-right"></div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        @click="getValidityItem('6 hours', '0.25')"
                      >
                        <div class="col-md-8">
                          <h6
                            class="dropdown_header_tex mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.drivers.sixHours") }}
                          </h6>
                        </div>
                        <div class="col-md-4 text-right"></div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        @click="getValidityItem('12 hours', '0.5')"
                      >
                        <div class="col-md-8">
                          <h6
                            class="dropdown_header_tex mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.drivers.twelveHours") }}
                          </h6>
                        </div>
                        <div class="col-md-4 text-right"></div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        @click="getValidityItem('24 hours', '1')"
                      >
                        <div class="col-md-8">
                          <h6
                            class="dropdown_header_tex mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.drivers.twentyFourHours") }}
                          </h6>
                        </div>
                        <div class="col-md-4 text-right"></div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        @click="getValidityItem('7 days', '7')"
                      >
                        <div class="col-md-8">
                          <h6
                            class="dropdown_header_tex mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.drivers.sevenDays") }}
                          </h6>
                        </div>
                        <div class="col-md-4 text-right"></div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        @click="getValidityItem('30 days', '30')"
                      >
                        <div class="col-md-8">
                          <h6
                            class="dropdown_header_tex mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.drivers.thirtyDays") }}
                          </h6>
                        </div>
                        <div class="col-md-4 text-right"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 pl-3 pr-3">
        <div class="row add_driver_row">
          <div class="col-md-12 col-lg-12 mr-3">
            <div class="row top_section_row">
              <div class="col-md-7">
                <span>
                  {{ $t("text.drivers.listOfDrivers") }}
                </span>
                <span> </span>
              </div>
              <div class="col-md-5 text-right">
                <!-- <button class="show_more_button remove_text_decoration"  @click="printVehiclesVoucher">
                    Download Sales Report
                  </button> -->
                <button
                  class="ml-3 show_more_button"
                  @click="print($event, 'print')"
                  style="width: 200px; padding: 5px; border: 0"
                >
                  {{ $t("text.drivers.printVoucher") }}
                  <i
                    class="fa fa-print ml-2"
                    name="username"
                    aria-hidden="true"
                    style="color: white"
                  ></i>
                </button>
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 loader1"
                />
              </div>
            </div>
            <div class="drivers_list position-relative">
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :locale="usedLang"
              >
                <!-- field="pin" -->
                <e-columns>
                  <e-column
                    field="index"
                    :template="checkBoxTemplate"
                    width="70"
                    :headerTemplate="selectAllTemplate"
                    headerText="#"
                  ></e-column>
                  <e-column
                    field="name"
                    width="250"
                    :headerText="$t('text.drivers.name')"
                  ></e-column>
                  <e-column
                    field="phone"
                    width="150"
                    :headerText="$t('text.drivers.phone')"
                  ></e-column>
                  <e-column
                    field="email"
                    width="200"
                    :headerText="$t('text.drivers.email')"
                  ></e-column>
                  <e-column
                    field="state"
                    width="150"
                    :headerText="$t('text.drivers.state')"
                  ></e-column>
                  <!-- <e-column :template="deleteTemplate" :headerText="$t('text.actionButtons.title')" width=200></e-column> -->
                  <e-column
                    :template="actionButtonsTemplate"
                    :headerText="$t('text.actionButtons.title')"
                    width="350"
                  ></e-column>
                </e-columns>
              </ejs-grid>
              <DropDown :details="details" />
              <TableLoader :showLoader="showLoader"></TableLoader>
            </div>
          </div>
        </div>
      </section>
      <!-- PDF DEISGN START -->
      <div
        style="margin: 0 auto; width: 95%; margin-top: -110px; display: none"
        id="pdfContent"
        class="canvas_div_pdf"
      >
        <div style="margin-top: -29px">
          <div style="flex: 40%; display: flex; justify-content: flex-start">
            <!-- <img  src="@/assets/img/pdf-logo.svg" style="margin-top: 9px;"   /> -->
            <svg
              version="1.1"
              class="navbar-logo"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="200px"
              height="101px"
              viewBox="0 0 536 101"
              style="
                enable-background: new 0 0 536 101;
                margin-top: 20px;
                margin-left: 15px;
              "
              xml:space="preserve"
            >
              <g id="Layer_1_1_">
                <g>
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M27.281,60.011c0,7.619,0,15.238,0,22.857c0,5.052,0.856,5.934,5.774,5.934
                                        c12.129,0.001,24.259,0.004,36.388,0c4.009-0.002,5.141-1.129,5.146-5.15c0.01-8.771,0.052-17.541-0.038-26.311
                                        c-0.019-1.874,0.381-2.585,2.427-2.549c7.182,0.126,14.369,0.104,21.552,0.011c1.908-0.024,2.266,0.472,2.046,2.383
                                        c-2.767,24.038-23.497,42.961-48.1,43.787C28.181,101.79,6.229,84.241,1.848,60.493C-3.256,32.844,14.416,6.905,41.924,1.672
                                        c26.914-5.12,52.912,12.886,58.258,40.247c0.511,2.611-0.009,3.32-2.719,3.244c-6.899-0.192-13.808-0.123-20.71-0.023
                                        c-1.726,0.025-2.234-0.45-2.2-2.181c0.106-5.409,0.06-10.823,0.033-16.234c-0.018-3.496-1.248-4.75-4.688-4.755
                                        c-12.596-0.018-25.191-0.016-37.787-0.001c-3.638,0.004-4.792,1.192-4.826,4.916c-0.028,3.079,0.01,6.157-0.011,9.237
                                        c-0.004,0.61,0.234,1.715-0.492,1.688c-3.386-0.123-4.318,3.335-6.82,4.463c-0.858,0.387-1.696,1.03-0.35,2.008
                                        c1.137,0.826,0.095,1.702-0.174,2.449c-2.404,6.688-4.897,13.337-5.548,20.503c-0.196,2.161-0.237,4.294,0.368,6.386
                                        c0.773,2.666,2.751,4.069,5.419,3.892c2.632-0.177,3.702-1.748,4.292-4.229c0.704-2.957,0.129-5.972,0.94-8.951
                                        C25.354,62.692,25.873,61.276,27.281,60.011z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M50.744,27.774c4.283,0,8.566-0.021,12.85,0.006c3.396,0.021,4.423,1.086,4.437,4.552
                                        c0.015,3.725-0.009,7.448,0.005,11.174c0.01,2.55-1.335,3.8-3.784,3.81c-8.846,0.035-17.692,0.026-26.538,0.008
                                        c-2.442-0.006-3.871-1.209-3.896-3.731c-0.04-4.003-0.07-8.009,0.009-12.011c0.047-2.374,0.918-3.951,3.789-3.846
                                        C41.985,27.894,46.367,27.776,50.744,27.774z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M27.294,43.142c0,4.042-0.058,7.647,0.032,11.249c0.03,1.191-0.456,1.833-1.332,2.515
                                        c-2.786,2.164-3.834,5.063-3.48,8.563c0.26,2.58,0.182,5.138-1.02,7.558c-0.923,1.86-2.715,2.371-3.927,0.826
                                        c-1.072-1.367-1.897-3.072-1.624-4.852c1.158-7.528,3.394-14.762,6.375-21.764c0.206-0.482,0.263-1.361,0.875-1.287
                                        C25.22,46.2,25.71,44.327,27.294,43.142z"
                  />
                </g>
                <g>
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M401.564,26.344c1.023-1.583,1.809-2.946,2.734-4.202c5.465-7.394,12.766-11.345,22.004-11.52
                                        c3.445-0.065,6.902-0.182,10.322,0.469c11.768,2.243,21.215,12.602,21.604,24.604c0.404,12.485,0.135,24.992,0.168,37.488
                                        c0.006,1.49-0.488,2.723-2.123,2.7c-1.779-0.026-2.188-1.349-2.186-2.94c0.025-11.752,0.078-23.504-0.006-35.256
                                        c-0.08-11.142-7.521-20.359-18.189-22.418c-4.594-0.886-9.32-0.875-13.916,0.001c-10.523,2.007-18.129,11.298-18.203,22.126
                                        c-0.08,11.471-0.02,22.943-0.021,34.416c0,0.745,0.066,1.506-0.053,2.233c-0.189,1.137-0.93,1.869-2.1,1.858
                                        c-1.191-0.014-1.854-0.812-2.008-1.944c-0.1-0.733-0.045-1.489-0.045-2.234c-0.002-11.099,0.025-22.196-0.008-33.296
                                        c-0.043-13.87-9.76-23.583-23.592-23.592c-2.979-0.002-5.963-0.202-8.918,0.45c-10.381,2.288-17.957,11.45-18.025,22.057
                                        c-0.072,11.563-0.016,23.13-0.021,34.694c0,0.744,0.066,1.515-0.1,2.227c-0.225,0.979-0.895,1.661-1.975,1.639
                                        c-1.051-0.021-1.773-0.619-1.979-1.646c-0.143-0.722-0.115-1.481-0.115-2.226c-0.008-11.191-0.023-22.385,0-33.576
                                        c0.035-16.158,11.746-27.795,27.939-27.863c4.586-0.02,9.133,0.053,13.512,1.693C392.648,14.677,396.6,18.249,401.564,26.344z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M195.684,64.719c0,11.063-0.021,21.388,0.025,31.712c0.008,1.635,0.064,2.77-2.207,2.782
                                        c-2.373,0.014-1.934-1.401-1.934-2.747c-0.002-19.771-0.035-39.543,0.012-59.313c0.035-14.723,11.732-26.424,26.48-26.528
                                        c4.66-0.033,9.355-0.228,13.973,0.258c13.258,1.396,23.311,12.707,23.438,26.017c0.043,4.291,0.045,8.58-0.002,12.87
                                        c-0.156,14.353-11.91,26.046-26.301,26.179c-3.822,0.035-7.648,0.035-11.471-0.002c-7.035-0.07-13.078-2.611-18.17-7.442
                                        C198.391,67.423,197.293,66.306,195.684,64.719z M251.287,43.183c-0.018,0-0.029,0-0.045,0c0-2.517,0.135-5.043-0.023-7.551
                                        c-0.74-11.713-10.146-20.632-21.885-20.794c-3.916-0.054-7.834-0.06-11.75,0.003c-12.113,0.189-21.715,9.839-21.887,21.994
                                        c-0.063,4.195-0.027,8.392-0.012,12.588c0.049,12.313,9.479,21.995,21.832,22.339c4.006,0.112,8.021,0.11,12.027-0.001
                                        c12.004-0.333,21.289-9.577,21.729-21.586C251.359,47.848,251.287,45.514,251.287,43.183z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M476.199,64.64c0,11.107-0.021,21.54,0.021,31.973c0.006,1.566-0.047,2.56-2.119,2.596
                                        c-2.221,0.037-2.035-1.176-2.033-2.637c0.02-19.771-0.016-39.541,0.021-59.313c0.025-13.794,10.148-25.109,23.879-26.455
                                        c5.465-0.535,11.014-0.549,16.48,0.04c13.387,1.442,23.438,12.745,23.535,26.229c0.029,4.195-0.035,8.394,0.014,12.59
                                        c0.086,7.309-2.797,13.646-7.664,18.636c-4.156,4.262-9.662,7.058-15.869,7.485c-5.674,0.391-11.385,0.463-17.049-0.028
                                        c-5.949-0.517-11.072-3.112-15.381-7.261C478.908,67.409,477.826,66.278,476.199,64.64z M531.752,43.353c0.025,0,0.051,0,0.076,0
                                        c0-2.238,0.063-4.478-0.012-6.713c-0.404-12.423-9.922-21.702-22.352-21.806c-3.729-0.032-7.461-0.046-11.189,0.003
                                        c-12.279,0.156-21.893,9.783-22.066,22.107c-0.057,4.103-0.021,8.207-0.008,12.31c0.039,12.502,9.475,22.21,21.945,22.513
                                        c4.008,0.098,8.021,0.114,12.027-0.01c11.563-0.359,20.654-9.035,21.547-20.575C531.922,48.587,531.752,45.964,531.752,43.353z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M143.815,51.967c-9.14,0-18.281,0.047-27.421-0.037c-1.954-0.019-2.561,0.254-1.537,2.236
                                        c1.322,2.559,2.153,5.366,3.839,7.745c4.585,6.469,10.873,9.783,18.782,9.854c8.58,0.078,17.162,0.02,25.742,0.02
                                        c0.654,0,1.307,0.014,1.959-0.002c1.48-0.03,2.746,0.453,2.719,2.094c-0.025,1.583-1.225,2.095-2.738,2.089
                                        c-7.461-0.026-14.923,0.013-22.385-0.021c-3.074-0.016-6.19,0.145-9.214-0.291c-12.305-1.771-21.333-11.39-22.808-24.438
                                        c-0.627-5.554-0.628-11.211-0.016-16.763c1.388-12.579,11.298-22.338,23.911-23.615c5.746-0.583,11.572-0.598,17.318,0.029
                                        c13.457,1.465,23.623,12.832,23.834,26.389c0.052,3.264,0.033,6.529,0.006,9.793c-0.028,3.646-1.254,4.902-4.85,4.911
                                        C161.91,51.979,152.862,51.967,143.815,51.967z M143.002,47.854c8.76,0,17.519,0.015,26.278-0.02
                                        c0.964-0.003,2.483,0.587,2.322-1.373c-0.401-4.862,0.476-9.705-0.978-14.628c-3.039-10.297-11.043-16.895-21.713-16.999
                                        c-4.007-0.039-8.02,0.135-12.02-0.03c-9.33-0.385-19.342,8.409-21.442,16.88c-1.142,4.608-0.503,9.276-0.774,13.911
                                        c-0.109,1.861,0.487,2.327,2.328,2.305C125.669,47.796,134.335,47.854,143.002,47.854z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M276.727,32.351c-0.002,5.131,0.041,10.262-0.012,15.393c-0.068,6.734,2.666,11.93,6.869,17.315
                                        c6.525,8.361,26.656,8.339,33.705,2.87c6.211-4.818,9.924-10.807,9.969-18.766c0.066-11.473,0.02-22.947,0.025-34.422
                                        c0-0.834-0.043-1.692,0.123-2.5c0.184-0.885,0.863-1.498,1.768-1.574c1.031-0.088,1.85,0.48,2.119,1.47
                                        c0.213,0.788,0.186,1.654,0.188,2.485c0.012,11.193-0.129,22.391,0.039,33.582c0.232,15.693-12.771,27.941-27.75,27.886
                                        c-8.154-0.03-15.461-1.667-22.08-6.396c-1.813-1.293-2.77-3.22-4.012-4.949c-3.359-4.69-5.119-9.92-5.139-15.684
                                        c-0.041-11.66-0.008-23.322-0.025-34.982c-0.004-1.581,0.064-3.301,2.033-3.357c2.225-0.064,2.191,1.786,2.188,3.438
                                        C276.717,20.223,276.727,26.286,276.727,32.351z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M284.592,99.218c-0.637-2.827-0.285-5.307-0.289-7.751c-0.002-1.05,0.867-1.172,1.574-0.573
                                        c0.471,0.397,0.729,1.057,1.053,1.616c0.418,0.729,0.775,1.59,1.83,1.381c1.281-0.254,0.582-1.351,0.756-2.065
                                        c0.105-0.438-0.006-0.938,1.113-1.514c0,2.762,0.047,5.262-0.023,7.758c-0.025,0.959-0.742,0.93-1.406,0.564
                                        c-0.229-0.124-0.365-0.415-0.539-0.633c-0.826-1.029-0.883-3.239-2.396-3.001C284.387,95.295,286.063,97.683,284.592,99.218z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M325.904,91.835c-0.852-0.133-1.699-0.369-2.553-0.376c-1.389-0.013-2.576,0.862-2.521,2.099
                                        c0.061,1.332-0.479,3.053,1.104,4.044c1.104,0.689,2.227,0.084,2.754-0.575c0.99-1.236-0.688-1.016-1.137-1.498
                                        c-0.229-0.248-0.395-0.56-0.689-0.987c1.186-0.185,2.525-0.728,3.094,0.335c0.459,0.857,0.381,2.31-0.033,3.244
                                        c-0.5,1.14-1.914,0.955-3.014,0.849c-2.031-0.2-3.199-1.44-3.488-3.405c-0.297-2.015,0.344-3.74,2.24-4.684
                                        C323.201,90.114,324.73,90.198,325.904,91.835z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M333.104,98.966c0-2.561-0.041-4.932,0.016-7.299c0.039-1.693,1.414-1.127,2.295-1.143
                                        c1.418-0.021,3.234,0.928,2.617,2.059c-1.295,2.356,0.006,4.167,0.555,6.162c-1.391,0.324-1.357-0.693-1.563-1.287
                                        c-0.354-1.037-1.127-2.04-1.996-1.894c-0.988,0.166-0.754,1.503-0.789,2.412C334.223,98.356,334.127,98.707,333.104,98.966z
                                          M337.023,92.884c-0.111-0.875-0.639-1.255-1.488-1.354c-0.957-0.112-1.4,0.227-1.313,1.217c0.064,0.707-0.18,1.604,1.01,1.561
                                        C336.166,94.272,336.818,93.853,337.023,92.884z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M455.793,98.929c-1.551,0.329-1.922-0.557-1.813-2.05c0.096-1.291,0.164-2.613-0.014-3.886
                                        c-0.313-2.254,0.76-2.734,2.693-2.498c2.518,0.309,3.953,2.015,3.766,4.584C460.244,97.61,458.686,98.952,455.793,98.929z
                                          M455.084,94.243c0.355,1.35-0.791,3.548,1.824,3.557c1.912,0.007,2.352-1.541,2.332-3.154c-0.021-1.82-0.801-3.059-2.805-3.063
                                        C454.23,91.575,455.521,93.334,455.084,94.243z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M423.742,90.683c0,1.99,0.145,3.994-0.049,5.967c-0.143,1.443-1.264,2.228-2.729,2.354
                                        c-1.428,0.123-2.711-0.304-3.156-1.739c-0.682-2.207-0.377-4.452,0.113-6.667c1.111,1.528,0.529,3.213,0.67,4.813
                                        c0.113,1.298,0.363,2.519,1.912,2.627c1.75,0.123,2.053-1.31,2.166-2.567c0.146-1.606,0.035-3.233,0.035-4.853
                                        C423.051,90.638,423.396,90.659,423.742,90.683z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M399.99,91.36c-0.852,0.649-1.338,0.098-1.867,0.092c-0.695-0.006-1.33,0.062-1.531,0.857
                                        c-0.158,0.635,0.207,1.059,0.703,1.383c0.232,0.151,0.479,0.285,0.727,0.41c1.498,0.752,3.064,1.68,1.871,3.583
                                        c-1.238,1.982-3.063,1.632-4.82,0.526c0.188-0.809,0.701-0.641,1.088-0.436c1.203,0.647,2.299-0.197,2.645-0.853
                                        c0.523-0.981-0.635-1.529-1.482-1.935c-1.51-0.715-2.701-1.805-1.598-3.457C396.746,90.004,398.316,90.046,399.99,91.36z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M313.971,98.729c-1.979,0.122-3.479,0.683-4.879-0.308c-0.336-0.236-0.225-7.128,0.021-7.46
                                        c0.486-0.654,2.178-0.644,4.322,0.036c-0.611,1.59-3.33-0.715-3.314,1.689c0.01,1.713,1.82,1.119,2.969,1.629
                                        c-0.521,1.549-3.639-0.49-3.029,2.256C310.498,98.549,312.486,97.397,313.971,98.729z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M435.998,98.901c-1.291-0.139-1.256-1.264-1.734-1.979c-0.445-0.669-0.99-1.559-1.896-1.309
                                        c-0.953,0.264-0.371,1.272-0.5,1.941c-0.086,0.441,0.063,0.939-1.045,1.676c0-2.976-0.309-5.646,0.145-8.183
                                        c0.191-1.072,2.119-0.636,3.25-0.304c1.076,0.314,2.119,1.414,1.482,2.252c-1.529,2.014-0.271,3.481,0.402,5.146
                                        C436.182,98.34,436.041,98.623,435.998,98.901z M434.643,92.802c-0.127-0.938-0.787-1.223-1.699-1.287
                                        c-1.104-0.078-1.117,0.598-1.104,1.385c0.016,0.754-0.047,1.521,1.08,1.411C433.82,94.224,434.477,93.856,434.643,92.802z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M410.605,91.391c-0.682,0.604-1.182,0.072-1.699,0.056c-0.695-0.022-1.359,0.064-1.576,0.83
                                        c-0.219,0.771,0.365,1.185,0.916,1.543c0.311,0.203,0.654,0.357,0.99,0.52c1.068,0.51,1.965,1.188,1.82,2.52
                                        c-0.107,1.01-0.771,1.762-1.732,1.984c-1.215,0.283-2.523,0.48-3.566-1.025c0.504-0.057,0.775-0.164,0.982-0.096
                                        c1.092,0.374,2.344,0.838,2.943-0.49c0.68-1.496-0.844-1.756-1.734-2.289c-1.383-0.828-2.67-1.853-1.35-3.515
                                        C407.732,90.001,409.207,90.014,410.605,91.391z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M447.248,90.75c-0.639,1.872-3.563-0.589-3.482,2.178c0.064,2.229,2.359,0.33,2.949,1.703
                                        c-0.494,1.017-2.451-0.461-2.561,1.528c-0.139,2.488,2.324,1.173,3.357,2.546c-1.783,0.208-3.24,0.627-4.654-0.236
                                        c-0.324-0.196-0.355-7.22-0.027-7.444C444.23,90.062,445.695,90.497,447.248,90.75z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M369.686,90.114c-1.375,3.332-3.123,5.739-3.205,8.875c-0.014-3.147-1.643-5.629-3.201-8.584
                                        c2.35,0.459,1.902,2.67,3.32,3.265C367.777,92.976,367.592,91.161,369.686,90.114z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M296.797,90.696c1.955,0,3.912,0,5.869,0c-3.293,0.771-2.283,3.364-2.35,5.481
                                        c-0.027,0.892-0.006,1.782-0.006,3.448c-1.73-2.078-0.998-3.752-1.141-5.249c-0.152-1.599,0.625-3.746-3.314-2.509
                                        C296.17,91.479,296.482,91.089,296.797,90.696z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M355.088,99.071c-0.779-1.477-0.357-2.785-0.439-4.039c-0.111-1.76,0.74-4.034-2.629-3.991
                                        c2.227-0.796,4.197-0.444,6.391-0.224C353.15,92.038,357.232,96.526,355.088,99.071z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M276.447,98.821c0-2.729,0-5.463,0-8.191c0.229-0.002,0.459-0.004,0.688-0.006
                                        c0.404,2.724,0.211,5.462,0.137,8.195C276.998,98.819,276.723,98.819,276.447,98.821z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M345.336,98.829c0-2.735,0-5.471,0-8.207c0.152,0.009,0.305,0.018,0.455,0.023
                                        c0,2.738,0,5.477,0,8.213C345.641,98.85,345.488,98.84,345.336,98.829z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M434.643,92.802c-0.166,1.055-0.82,1.422-1.723,1.509c-1.127,0.109-1.064-0.657-1.08-1.411
                                        c-0.016-0.787,0-1.463,1.102-1.385C433.855,91.579,434.516,91.864,434.643,92.802z"
                  />
                  <path
                    style="fill: rgb(75, 44, 114)"
                    d="M383.953,98.911c2.461-2.394,4.619-1.762,6.924,0.307c-0.707-2.645-1.551-5.044-2.408-7.439
                                        c-0.16-0.443-0.418-0.851-0.953-0.873c-0.703-0.027-0.914,0.539-1.1,1.054C385.582,94.27,384.771,96.592,383.953,98.911z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div style="flex: 60%; display: flex; justify-content: flex-end">
            <!-- <img  src="@/assets/img/sm.png" style="transform: translate(37px, --67px);width: 124px;"  /> -->
            <svg
              style="transform: translate(9px, -97px)"
              xmlns="http://www.w3.org/2000/svg"
              width="166.023"
              height="75.414"
              viewBox="0 0 166.023 75.414"
            >
              <path
                id="Subtraction_1"
                data-name="Subtraction 1"
                d="M2012.023,191.144a5.979,5.979,0,0,1-3.028-.824l-1.15-.676a6.025,6.025,0,0,1-2.135-8.223l25.622-43.587a6.128,6.128,0,0,0,.706-4.506,5.52,5.52,0,0,0-2.578-3.562,5.457,5.457,0,0,0-2.763-.747,6.085,6.085,0,0,0-5.2,3.037l-17.871,30.4a6.019,6.019,0,0,1-8.222,2.135l-1.151-.677a6.025,6.025,0,0,1-2.134-8.223l14.065-23.926a6.129,6.129,0,0,0,.706-4.506,5.521,5.521,0,0,0-2.578-3.562,5.455,5.455,0,0,0-2.764-.747,6.084,6.084,0,0,0-5.195,3.037l-31.823,54.137a6.044,6.044,0,0,1-5.2,2.959,5.972,5.972,0,0,1-3.026-.824l-1.152-.677a6.015,6.015,0,0,1-2.134-8.222l20.126-34.237a6.13,6.13,0,0,0,.706-4.506,5.519,5.519,0,0,0-2.578-3.561,5.453,5.453,0,0,0-2.763-.747,6.082,6.082,0,0,0-5.194,3.037l-24.072,40.949a6.043,6.043,0,0,1-5.2,2.958,5.977,5.977,0,0,1-3.027-.824l-1.152-.676a6.015,6.015,0,0,1-2.134-8.222l5.609-9.544a6.125,6.125,0,0,0,.707-4.5,5.519,5.519,0,0,0-2.577-3.562,5.459,5.459,0,0,0-2.764-.747,6.083,6.083,0,0,0-5.2,3.036l-16.6,28.242a6.042,6.042,0,0,1-5.2,2.958,5.974,5.974,0,0,1-3.026-.824l-1.152-.676a6.025,6.025,0,0,1-2.134-8.222l33.48-56.955h130.33l-42,71.456A6.042,6.042,0,0,1,2012.023,191.144Z"
                transform="translate(-1894.074 -116.23)"
                fill="#4b2d73"
                stroke="rgba(0,0,0,0)"
                stroke-miterlimit="10"
                stroke-width="1"
              />
            </svg>
          </div>
        </div>
        <div
          class="text-center"
          style="
            filter: progid:DXImageTransform.Microsoft.BasicImage(Rotation=1);
            background: white;
            margin-top: -23px;
            height: auto;
            padding: 25px;
            display: flex;
            transform: translate(10px, -72px);
          "
        >
          <div style="flex: 40%">
            <h3 style="color: #4b2d73; font-size: 25px; font-weight: 600"></h3>
            <div
              style="height: 2px;
                      width: 150px;
                      background: rgb(75, 45, 115);
                      -webkit-print-color-adjust: exact;
                      margin-top: -28px;
                      width: 137px;
                  }"
            ></div>
            <div>
              <h2 style="color: #2f2828; font-size: 16px; font-weight: 900">
                {{ userName }}
              </h2>
            </div>
            <div>
              <h3
                style="
                  color: #4b2d73;
                  font-size: 100px;
                  margin: -15px;
                  padding-left: 10px;
                "
              >
                <!-- {{branch.companyNameAbbr}} -->
                <!-- <img :src="branchIcon" style="margin-top: 10px;width: 200px;"/> -->
                {{ userName.charAt(0).toUpperCase() }}
              </h3>
            </div>
          </div>
          <div
            style="
              flex: 60%;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            "
          >
            <div
              class="first_tab"
              style="
                border-radius: 30px;
                margin-top: -20px;
                width: 100%;
                height: 50px;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: #4b2d73;
                color: white;
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: 700;
                font-size: 20px;
              "
            >
              {{ userName }}
            </div>
            <div
              style="
                border-radius: 30px;
                width: 100%;
                margin: 2px;
                padding-left: 20px;
                height: 50px;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: #f6f9ff;
                color: white;
                display: flex;
                align-items: center;
              "
            >
              <div style="flex: 50%">
                <h3 style="color: #313233; font-size: 20px; font-weight: 800">
                  {{ $t("text.drivers.date") }}
                </h3>
              </div>
              <div style="flex: 50%">
                <h3 style="color: #4b2d73; font-size: 20px; font-weight: 800">
                  {{ todaysDate }}
                </h3>
              </div>
            </div>
            <div
              style="
                border-radius: 30px;
                width: 100%;
                padding-left: 20px;
                margin: 2px;
                height: 50px;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: #f6f9ff;
                color: white;
                display: flex;
                align-items: center;
              "
            >
              <div style="flex: 50%">
                <h3 style="color: #313233; font-size: 20px">
                  {{ $t("text.drivers.accountType") }}
                </h3>
              </div>
              <div style="flex: 50%">
                <h3 style="color: #4b2d73; font-size: 20px; font-weight: 800">
                  {{ $t("text.drivers.customer") }}
                </h3>
              </div>
            </div>
            <div
              style="
                border-radius: 30px;
                width: 100%;
                padding-left: 20px;
                margin: 2px;
                height: 50px;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: #f6f9ff;
                color: white;
                display: flex;
                align-items: center;
              "
            >
              <div style="flex: 50%">
                <h3 style="color: #313233; font-size: 16px">
                  {{ $t("text.drivers.currency") }}
                </h3>
              </div>
              <div style="flex: 50%">
                <h3 style="color: #4b2d73; font-size: 20px; font-weight: 800">
                  {{ $t("text.drivers.naira") }}
                </h3>
              </div>
            </div>
            <div
              style="
                border-radius: 30px;
                width: 100%;
                padding-left: 20px;
                margin: 2px;
                height: 50px;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: #f6f9ff;
                color: white;
                display: flex;
                align-items: center;
              "
            >
              <div style="flex: 50%">
                <h3 style="color: #313233; ffont-size: 20px; font-weight: 800">
                  {{ $t("text.drivers.voucherAmount") }}
                </h3>
              </div>
              <div style="flex: 50%">
                <h3 style="color: #4b2d73; font-size: 16px; font-weight: 700">
                  ₦ {{ amount }}
                </h3>
              </div>
            </div>
            <div
              style="
                border-radius: 30px;
                width: 100%;
                padding-left: 20px;
                margin: 2px;
                height: 50px;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: #f6f9ff;
                color: white;
                display: flex;
                align-items: center;
              "
            >
              <div style="flex: 50%">
                <h3 style="color: #313233; ffont-size: 20px; font-weight: 800">
                  {{ $t("text.drivers.returnBalanceTo") }}
                </h3>
              </div>
              <div style="flex: 50%">
                <h3 style="color: #4b2d73; font-size: 20px; font-weight: 700">
                  {{ returnBalanceTo }}
                </h3>
              </div>
            </div>
            <div
              style="
                border-radius: 30px;
                width: 100%;
                padding-left: 20px;
                margin: 2px;
                height: 50px;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: #f6f9ff;
                color: white;
                display: flex;
                align-items: center;
              "
            >
              <div style="flex: 50%">
                <h3 style="color: #313233; ffont-size: 20px; font-weight: 800">
                  {{ $t("text.drivers.validity") }}
                </h3>
              </div>
              <div style="flex: 50%">
                <h3 style="color: #4b2d73; font-size: 20px; font-weight: 700">
                  {{ validity }}
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            margin: 0 auto;
            width: 100%;
            transform: translate(0px, -78px);
            background: #4b2d73;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          "
        >
          <h3 style="color: white; text-align: center; padding: 20px">
            {{ $t("text.drivers.driversListGVoucher") }}
          </h3>
        </div>
        <table style="width: 100%; margin-top: -97px">
          <thead>
            <tr
              style="
                height: 70px;
                color: #4b2d73;
                font-size: 15px;
                font-weight: 500;
                background: #edebff;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              "
            >
              <th style="text-align: center; margin-left: 30px">#</th>
              <th style="text-align: center">{{ $t("text.form.name") }}</th>
              <th style="text-align: center">{{ $t("text.form.phoneNo") }}</th>
              <th style="text-align: center">{{ $t("text.form.email") }}</th>
              <th style="text-align: center">{{ $t("text.form.state") }}</th>
            </tr>
          </thead>
          <tbody style="width: 95%; margin: 0 auto">
            <tr
              class="data__row"
              v-for="(driver, i) in driversArray"
              :key="i"
              style="height: 70px"
            >
              <td style="text-align: center; margin-left: 30px">{{ i + 1 }}</td>
              <td style="text-align: center">{{ driver.name }}</td>
              <td style="text-align: center">{{ driver.phone }}</td>
              <td style="text-align: center">{{ driver.email }}</td>
              <td style="text-align: center">{{ driver.state }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- PDF DESIGN ENDS -->
    </MasterLayout>
    <LinkVehicle :driverInfo="driverInfo" />
    <EditDriver :driverInfo="driverInfo" />
    <AddDriverModal />
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/danskebank.jpg";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import DropDown from "@/components/Templates/Dropdown/dropdown.vue";
import LinkVehicle from "@/components/modals/Drivers/linkVehicle.vue";
import DriversActions from "@/components/TableTemplates/Customer/driversTemplates.vue";
import AddDriverModal from "@/components/modals/addDriver.vue";
import EditDriver from "@/components/modals/Drivers/editDriver.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Drivers - Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
    DropDown,
    LinkVehicle,
    AddDriverModal,
    EditDriver,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      backgroundUrl,
      cardBackgroundUrl,
      drivers: [],
      showLoader: false,
      driversCount: 0,
      name: null,
      vehicles: [],
      phone: null,
      todaysDate: new Date(),
      email: null,
      code: null,
      address: null,
      state: null,
      vehicleId: "link driver to vehicle",
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      isButtonDisabled: false,
      driversArray: [],
      amount: "",
      returnBalanceTo: "",
      validity: "",
      validityValue: "",
      mode: null,
      toggleReturnBalanceToDropDown: false,
      toggleValidityDropdown: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      details: {
        queryStrings: { driverId: "" },
        itemData: {},
        info: [{ name: "Mapped Vehicles", link: "drivers_vehicles" }],
        modals: [{ name: "Map Vehicle", link: "LinkVehicle" }],
        delete: {
          hasDelete: false,
          deleteName: "",
          name: "Unlink Vehicle",
          query: "driverId",
        },
      },
      driverInfo: {},
      actionButtonsTemplate: function () {
        return {
          template: DriversActions,
        };
      },
      checkBoxTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `<div><input type="checkbox" :checked="data.checked" v-on:change="createDriverArray($event, data)"/></div>`,

            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              createDriverArray: function (e, driver) {
                this.$eventHub.$emit("driverCheck", e, driver);
              },
            },
          }),
        };
      },
      selectAllTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<div><input type="checkbox" id="selectAllDrivers" v-on:change="selectAllDrivers($event)"/></div>',
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              selectAllDrivers: function (e) {
                this.$eventHub.$emit("selectAllDrivers", e);
              },
            },
          }),
        };
      },
      deleteTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<button class="delete_btn" v-on:click="removeDriver(data.id)">{{data.deleteButton}}</button>',
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              removeDriver: function (id) {
                this.$eventHub.$emit("deleteDriver", id);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("driverCheck", (event, driver) => {
      this.createDriversVoucherArray(event, driver);
    });

    this.$eventHub.$on("selectAllDrivers", (event) => {
      this.selectAllDrivers(event);
    });

    this.$eventHub.$on("getDrivers", (event) => {
      this.getDrivers();
    });

    this.$eventHub.$on("editDriver", (data) => {
      this.driverInfo = data;
      this.$modal.show("editDriver");
    });

    this.$eventHub.$on("deleteDriver", (id) => {
      this.deleteDriver(id);
    });

    this.$eventHub.$on("LinkVehicle", (data) => {
      this.openLinkVehicleModal(data);
    });

    this.$eventHub.$on("fetchDrivers", () => {
      this.getDrivers();
    });

    this.$eventHub.$on("showExtraDriversOptions", (data, that) => {
      this.details.itemData = data;
      this.details.queryStrings.driverId = data.id;
      const viewData =
        document.getElementsByClassName("e-grid")[0].ej2_instances[0]
          .currentViewData;
      const option = document.getElementById("myDropdown");
      option.classList.add("show");
      let index;
      const findindex = viewData.findIndex(
        (driver) => driver.index === data.index
      );
      if (data.index > 10) {
        index = findindex;
      }
      if (data.index <= 10) {
        index = data.index;
      }

      option.style.top = `${(80 * index + (95 - index * 2)).toString()}px`;
    });

    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDay();
    this.todaysDate = day + "-" + month + "-" + year;
    this.todaysDate = this.$moment(date, "DD-MM-YYYY").format("MMMM D, YYYY");
  },
  beforeDestroy() {
    this.$eventHub.$off("driverCheck");
    this.$eventHub.$off("selectAllDrivers");
    this.$eventHub.$off("deleteDriver");
    document.removeEventListener("mousedown", this.handleClick);
  },
  computed: {
    userName() {
      if (localStorage.getItem("userDetails")) {
        return this.userDetails.firstName + "  " + this.userDetails.lastName;
      } else {
        return "Username";
      }
    },
  },
  mounted() {
    $(".balance_to_input").css("color", "white");
    $(".amount_input").css("color", "white");
    this.getDrivers();

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    document.addEventListener("mousedown", this.handleClick);
    this.getVehicles();
  },
  methods: {
    openLinkVehicleModal(data) {
      this.$modal.show("LinkVehicle");
      this.driverInfo = data;
    },
    handleClick(e) {
      if (this.$refs.balance_to_drop_down_menu) {
        if (this.$refs.balance_to_drop_down_menu.contains(e.target)) {
          return;
        }
        this.$refs.balance_to_drop_down_menu.style.display = "none";
      }
    },
    printDriversVoucher() {
      var elementHTML = $("#pdfContent").html();
      var myWindow = window.open("", "", "width=1000,height=700");
      myWindow.document.write(elementHTML);
      var style = myWindow.document.createElement("style");
      style.innerHTML = `
      @page {
        size: auto;  /* auto is the initial value */
        margin: 0mm; /* this affects the margin in the printer settings */
      }
      html {
        background-color: #FFFFFF;
        margin: 0px; /* this affects the margin on the HTML before sending to printer */
      }
      body {
        margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
        margin: 0mm;
      }
      .data__row:nth-child(even) {
        background: #dbdbdb;
        -webkit-print-color-adjust: exact;  print-color-adjust: exact;
      }

      .data__row:nth-child(odd) {
        background: white;
        -webkit-print-color-adjust: exact;  print-color-adjust: exact;
      }
      table {
        border-collapse: collapse;
      }
      `;
      myWindow.document.head.appendChild(style);
      myWindow.document.close();
      myWindow.focus();
      myWindow.print();
      myWindow.close();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Drivers.pdf",
          };
          this.$refs.dataGrid.getColumns()[5].visible = false;
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: "Drivers.xlsx",
          };
          this.$refs.dataGrid.excelExport(excelExportProperties);
          break;
      }
      setTimeout(() => {
        this.$refs.dataGrid.getColumns()[5].visible = true;
      }, 1000);
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    unselectAll() {
      $(":checkbox").each(function () {
        this.checked = false;
      });
      this.driversArray = [];
    },
    createDriversVoucherArray(event, driverInfo) {
      event.preventDefault();
      if (!event.target.checked) {
        let newDriversArray;
        let checkDrivers = this.driversArray.filter(
          (driver) => driver.id === driverInfo.id
        );
        if (checkDrivers) {
          newDriversArray = this.driversArray.filter(
            (driver) => driver.id !== driverInfo.id
          );
        }
        this.drivers.forEach((cur) => {
          if (cur.id == driverInfo.id) {
            cur.checked = false;
          }
        });
        $("#selectAllDrivers").each(function () {
          this.checked = false;
        });
        this.driversArray = newDriversArray;
      } else {
        let newDriversArray;
        let checkDriver = this.driversArray.filter(
          (driver) => driver.id === driverInfo.id
        );
        if (!checkDriver.length) {
          this.driversArray.push(driverInfo);
          this.drivers.forEach((cur) => {
            if (cur.id == driverInfo.id) {
              cur.checked = true;
            }
          });
        }
        let arr = this.drivers.filter((cur) => cur.checked !== true);
        if (!arr.length) {
          $("#selectAllDrivers").each(function () {
            this.checked = true;
          });
        }
      }
    },
    getVehicles() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Track/Vehicles`,
          configObject.authConfig()
        )
        .then((response) => {
          this.vehicles = response.data.vehicles;
        })
        .catch((error) => {});
    },
    // linkVehicles(res) {
    //   const data ={
    //     "driverId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //     "vehicleId": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    //   }
    //   this.axios
    //     .post(
    //       `${configObject.apiBaseUrl}/Drivers/LinkToVehicle`, data, configObject.authConfig()
    //     )
    //     .then((res) => {

    //     })
    //     .catch(error => {

    //     });
    // },
    selectAllDrivers(event) {
      event.preventDefault();
      let _this = this;
      if (event.target.checked) {
        $(":checkbox").each(function () {
          this.checked = true;
        });
        this.drivers.forEach((cur) => {
          cur.checked = true;
        });
        this.driversArray = this.drivers;
      } else {
        $(":checkbox").each(function () {
          this.checked = false;
        });
        this.drivers.forEach((cur) => {
          cur.checked = false;
        });
        _this.driversArray = [];
      }
    },
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    validEmail(email) {
      var re =
        /^[a-z][a-zA-Z0-9_.]*(\.[a-zA-Z][a-zA-Z0-9_.]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;
      return re.test(email);
    },

    toggleReturnBalanceToDropDownDisplay() {
      this.toggleValidityDropdown = false;
      this.toggleReturnBalanceToDropDown = !this.toggleReturnBalanceToDropDown;
    },
    toggleValidityDropDownDisplay() {
      this.toggleValidityDropdown = !this.toggleValidityDropdown;
      this.toggleReturnBalanceToDropDown = false;
    },
    getValidityItem(name, value) {
      this.validity = name;
      this.validityValue = value;
      this.toggleValidityDropdown = !this.toggleValidityDropdown;
    },
    getReturnBalanaceToDropdownItem(returnBalanceToDropdownItem) {
      this.returnBalanceTo = returnBalanceToDropdownItem;
      this.toggleReturnBalanceToDropDown = !this.toggleReturnBalanceToDropDown;
      $(".balance_to_input").css("color", "white");
      $(".balance_to_input").val(returnBalanceToDropdownItem);
    },
    captureFormEvents($event) {
      if ($event.target.placeholder === this.$t("text.drivers.driversName")) {
        if ($event.target.value === "") {
          this.$refs.name_error_template.style.display = "block";
          this.$refs.name_input_div.style.border = "1px solid red";
          this.$refs.name_error_template.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.name_error_template.style.display = "none";
          this.$refs.name_input_div.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }

      if ($event.target.placeholder === this.$t("text.drivers.phoneNumber")) {
        if ($event.target.value === "") {
          this.$refs.phone_error_template.style.display = "block";
          // this.$refs.phone_error_template.innerHTML =
          //   "Phone Number field cannot be blank";
          this.$refs.phone_input_div.style.border = "1px solid red";
          this.$refs.phone_error_template.style.color = "red";
          this.formIsValid = false;
        } else {
          if (
            $event.target.value.length < 10 ||
            $event.target.value.length > 13
          ) {
            this.$refs.phone_error_template.style.display = "block";
            this.$refs.phone_error_template.style.color = "red";
            this.$refs.phone_input_div.style.border = "1px solid red";
            this.$refs.phone_error_template.innerHTML = this.$t(
              "text.errors.shortPhoneNumber"
            );
            this.formIsValid = false;
            return;
          }
          this.$refs.phone_error_template.style.display = "none";
          this.$refs.phone_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }

      if ($event.target.placeholder === this.$t("text.drivers.address")) {
        if ($event.target.value === "") {
          this.$refs.address_error_message.style.display = "block";
          this.$refs.address_error_message.style.color = "red";
          this.$refs.address_input_div.style.border = "1px solid red";
          this.formIsValid = false;
        } else {
          this.$refs.address_error_message.style.display = "none";
          this.$refs.address_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }

      if ($event.target.placeholder === this.$t("text.drivers.state")) {
        if ($event.target.value === "") {
          this.$refs.state_error_message.style.display = "block";
          this.$refs.state_error_message.style.color = "red";
          this.$refs.state_input_div.style.border = "1px solid red";
          this.formIsValid = false;
        } else {
          this.$refs.state_error_message.style.display = "none";
          this.$refs.state_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
    },
    sendVoucherToDrivers($event, mode) {
      $event.preventDefault();
      if (!this.amount) {
        this.$toast.open({
          message: this.$t("text.drivers.amountMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!(this.amount > 0)) {
        this.$toast.open({
          message: this.$t("text.drivers.amountZeroError"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.returnBalanceTo) {
        this.$toast.open({
          message: this.$t("text.drivers.balanceToMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.validity) {
        this.$toast.open({
          message: this.$t("text.drivers.validityMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.driversArray.length > 0) {
        if (this.returnBalanceTo === "") {
          this.returnBalanceTo = "Wallet";
        }

        if (this.validityValue === "") {
          this.validityValue = "never";
        }
        if (this.amount > 0) {
          let vecArr = [];
          this.driversArray.forEach((cur) => {
            vecArr.push({
              id: cur.id,
              name: cur.name,
              phone: cur.phone,
            });
          });
          let data = {
            recipients: vecArr,
            amount: parseFloat(this.amount),
            mode: mode,
            returnBalanceTo: this.returnBalanceTo,
            validity: this.validityValue,
          };

          this.isButtonDisabled = true;
          $(".loader").show();
          let _this = this;

          this.axios
            .post(
              `${configObject.apiBaseUrl}/Drivers/SendVouchers`,
              data,
              configObject.authConfig()
            )
            .then((res) => {
              _this.getDrivers();
              let voucherDetails = res.data;
              voucherDetails.forEach((el) => {
                el.amount = parseFloat(el.amount);
                el.source = "driver";
              });
              localStorage.setItem(
                "voucherToSendSmsDetails",
                JSON.stringify(voucherDetails)
              );
              this.$router.push({ name: "send_confirmed_voucher" });
              this.amount = null;
              (this.returnBalanceTo = null), (this.validity = null);
              $(".loader").hide();
              this.isButtonDisabled = false;
              this.driversArray = [];
              this.unselectAll();
            })
            .catch((error) => {
              this.amount = null;
              (this.returnBalanceTo = null), (this.validity = null);
              this.unselectAll();
              $(".loader").hide();
              this.isButtonDisabled = false;
              this.$toast.open({
                message: error.response.data.message,
                type: "error",
                duration: 5000,
              });
            });
        } else {
          this.$toast.open({
            message: this.$t("text.drivers.amountZeroError"),
            type: "warning",
            duration: 5000,
          });
        }
      } else {
        this.$toast.open({
          message: this.$t("text.drivers.noDriverError"),
          type: "warning",
          duration: 5000,
        });
      }
    },
    print($event, mode) {
      $event.preventDefault();
      if (!this.amount) {
        this.$toast.open({
          message: this.$t("text.drivers.amountMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!(this.amount > 0)) {
        this.$toast.open({
          message: this.$t("text.drivers.amountZeroError"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.returnBalanceTo) {
        this.$toast.open({
          message: this.$t("text.drivers.balanceToMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.validity) {
        this.$toast.open({
          message: this.$t("text.drivers.validityMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.driversArray.length > 0) {
        if (this.returnBalanceTo === "") {
          this.returnBalanceTo = "Wallet";
        }

        if (this.validityValue === "") {
          this.validityValue = "never";
        }
        if (this.amount > 0) {
          let vecArr = [];
          this.driversArray.forEach((cur) => {
            vecArr.push({
              id: cur.id,
              name: cur.name,
              phone: cur.phone,
            });
          });
          let data = {
            recipients: vecArr,
            amount: parseFloat(this.amount),
            mode: mode,
            returnBalanceTo: this.returnBalanceTo,
            validity: this.validityValue,
          };
          let _this = this;
          this.printDriversVoucher();
        } else {
          this.$toast.open({
            message: this.$t("text.drivers.amountZeroError"),
            type: "warning",
            duration: 5000,
          });
        }
      } else {
        this.$toast.open({
          message: this.$t("text.drivers.noDriverError"),
          type: "warning",
          duration: 5000,
        });
      }
    },

    openModal(modal) {
      this.$modal.show(modal);
    },
    getDrivers() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(`${configObject.apiBaseUrl}/Drivers`, configObject.authConfig())
        .then((response) => {
          this.driversCount = response.data.vehicles.length;
          this.showLoader = false;
          let index = 0;
          response.data.vehicles.forEach((driver) => {
            index++;
            driver.index = index;
            driver.checked = false;
            driver.deleteButton = this.$t("text.actionButtons.delete");
          });
          this.drivers = response.data.vehicles;
          grid.ej2Instances.setProperties({
            dataSource: this.drivers,
          });
          this.driversCount = response.data.vehicles.length;

          this.refreshGrid();
        })
        .catch((error) => {});
    },
  },
};
</script>
